import React from "react";
import useStyles from "../styles";
import { ReactComponent as Loader } from "../../../../images/analytics/ChartLoader.svg";
import { EmptyChart } from "../../components/EmptyChart";

export function ChartWrapper({
  loading,
  title,
  subtitle,
  children,
  isEmpty = false,
}) {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
      }}
    >
      {/* Header */}
      <div>
        <h3 style={{ fontSize: "18px", fontWeight: 700, margin: 0 }}>
          {title}
        </h3>
        {subtitle && (
          <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>
            {subtitle}
          </p>
        )}
      </div>

      {/* Content */}
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
          <Loader />
        </div>
      ) : isEmpty ? (
        <EmptyChart />
      ) : (
        <div style={{ width: "100%", height: "370px" }}>{children}</div>
      )}
    </div>
  );
}
